import {
  useCurrentAccountId,
  usePlans,
} from '@zapier/design-system-revenue/src/hooks';

import { PlanV2 } from '@zapier/design-system-revenue/src/types';

import {
  buildDowngradeWarningUrl,
  buildPlanChangeUrl,
} from '@zapier/design-system-revenue/src/utils';

import { DowngradeWarningPageParams } from '../DowngradeWarningPage';

export const useData = ({
  fromPlanName,
  interval,
  toPlanName,
}: DowngradeWarningPageParams) => {
  const { accountId } = useCurrentAccountId();
  const {
    data: { currentAccount, currentPlan, plans },
    isLoading,
  } = usePlans(accountId, {
    flatPlans: true,
  });

  const teamName = currentAccount?.name;
  const currentPlanType = currentPlan?.type ?? '';

  const toPlan = (plans as PlanV2[]).find(
    p => toPlanName === p.name.toLowerCase()
  );

  const toPlanType = toPlan?.type;

  const continueUrl =
    toPlanType === 'Free'
      ? buildDowngradeWarningUrl(fromPlanName, toPlanName, interval)
      : buildPlanChangeUrl('downgrade', fromPlanName, toPlanName, interval);

  return {
    continueUrl,
    currentPlanType,
    isLoading,
    teamName,
    toPlanType,
  };
};
